import { gql } from '@apollo/client';
import client from 'apollo/client';

const PQRS_FIELDS = `
  id
  subject
  status
  last_message_at
  created_at
  client { id full_name photo email }
  admin { id full_name photo }
`;

const PQRS_WITH_THREAD = `
  ${PQRS_FIELDS}
  messages {
    id
    body
    attachment_url
    attachment_name
    created_at
    author { id full_name photo role }
  }
`;

/**
 * Tickets del cliente autenticado (con hilo).
 */
const myPqrs = () =>
  client.query({
    query: gql`
      query myPqrs {
        myPqrs { ${PQRS_WITH_THREAD} }
      }
    `,
    fetchPolicy: 'network-only'
  });

/**
 * Lista admin paginada con filtros (estado / rango de fecha / nombre).
 */
const adminList = (payload = {}) => {
  const { pagination = { first: 20, page: 1 }, filters = {} } = payload;

  const statusFilter = filters.status?.length ? `status: [${filters.status.join(',')}]` : '';
  const searchFilter = filters.search ? `search: ${JSON.stringify(filters.search)}` : '';
  let dateFilter = '';
  if (filters.start_between?.start_date) {
    const endPart = filters.start_between.end_date
      ? `, end_date: "${filters.start_between.end_date}"`
      : '';
    dateFilter = `start_between: { start_date: "${filters.start_between.start_date}"${endPart} }`;
  }

  return client.query({
    query: gql`
      query pqrsTickets {
        pqrsTickets(
          ${statusFilter}
          ${searchFilter}
          ${dateFilter}
          first: ${pagination.first}
          page: ${pagination.page}
        ) {
          paginatorInfo { currentPage hasMorePages total lastPage }
          data { ${PQRS_FIELDS} }
        }
      }
    `,
    fetchPolicy: 'network-only'
  });
};

/**
 * Un ticket puntual (con hilo).
 */
const find = (id) =>
  client.query({
    query: gql`
      query pqrs($id: ID!) {
        pqrs(id: $id) { ${PQRS_WITH_THREAD} }
      }
    `,
    variables: { id },
    fetchPolicy: 'network-only'
  });

/**
 * Cliente abre un ticket.
 */
const create = (payload) =>
  client.mutate({
    mutation: gql`
      mutation createPqrs($subject: String!, $body: String!, $attachment: Upload) {
        createPqrs(subject: $subject, body: $body, attachment: $attachment) { ${PQRS_WITH_THREAD} }
      }
    `,
    variables: { subject: payload.subject, body: payload.body, attachment: payload.attachment ?? null }
  });

/**
 * Cliente o admin agregan un mensaje al hilo (texto y/o adjunto).
 */
const reply = (payload) =>
  client.mutate({
    mutation: gql`
      mutation replyPqrs($pqrs_id: ID!, $body: String, $attachment: Upload) {
        replyPqrs(pqrs_id: $pqrs_id, body: $body, attachment: $attachment) { ${PQRS_WITH_THREAD} }
      }
    `,
    variables: { pqrs_id: payload.pqrs_id, body: payload.body ?? '', attachment: payload.attachment ?? null }
  });

/**
 * Admin cambia el estado del ticket.
 */
const updateStatus = (payload) =>
  client.mutate({
    mutation: gql`
      mutation updatePqrsStatus($id: ID!, $status: PqrsStatus!) {
        updatePqrsStatus(id: $id, status: $status) { ${PQRS_WITH_THREAD} }
      }
    `,
    variables: { id: payload.id, status: payload.status }
  });

export default { myPqrs, adminList, find, create, reply, updateStatus };
